export const AUTH_MESSAGES = {
  SUCCESS: "success",
  CHANGE_PASSWORD: "Please change your password",
};

export const AUTH_ALERTS = {
  PASSWORD_EXPIRED: "Your password is too old, please change your password",
  ACCESS_DENIED: "You are not allowed to access.",
};